var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mpage"},[_vm._m(0),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"l-sjx"}),_vm._v("\n    左\n  ")])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"r-b-sjx"}),_vm._v("\n    右下\n  ")])
}]

export { render, staticRenderFns }